import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getRedirectPath } from "../../config/redirectHelper";

const PublicRoute = ({ children }: { children?: JSX.Element }) => {
  const location = useLocation();

  const token = localStorage.getItem("token");
  const rawUserData = localStorage.getItem("user_data");
  const userData = rawUserData ? JSON.parse(rawUserData) : null;

  const urlParams = new URLSearchParams(location.search);
  const verified = urlParams.get("verified");

  // if verified clear local storage
  if (verified) {
    localStorage.clear();
  }

  // if token and userdata exist and userrole is client redirect to report/run-payroll page else dashboard
  if (token && userData) {
    const redirectPath = getRedirectPath({
      role: userData?.roles?.role_name,
      userId: userData?.id,
      search: location.search,
    });

    return <Navigate to={redirectPath} replace />;
  }

  if (children) return children;
  return <Outlet />;
};

export default PublicRoute;

// import { Navigate, Outlet } from "react-router-dom";

// const PublicRoute = ({ children }: { children?: JSX.Element }) => {
//   const token = localStorage.getItem("token");
//   const rawUserData = localStorage.getItem("user_data");
//   let userData: any = null;
//   userData = rawUserData ? JSON.parse(rawUserData) : null;

//   const urlParams = new URLSearchParams(window.location.search);
//   const verified = urlParams.get("verified");

//   // redirect by role
//   const redirectByRole = (role: string) => {
//     switch (role) {
//       case "Admin":
//         return "/admin-dashboard";

//       case "User":
//         return "/user-dashboard";

//       case "Client":
//         return "/client-dashboard";

//       case "Employee":
//         return "/employee-dashboard";

//       default:
//         return "/dashboard";
//     }
//   };

//   if (verified) {
//     localStorage.clear();
//   }

//   if (token && userData) {
//     const role = userData?.roles?.role_name;
//     let redirectPath = redirectByRole(role);

//     // Client report redirect logic
//     if (role === "Client") {
//       const rawRedirect = urlParams.get("redirect");

//       if (rawRedirect?.startsWith("/report")) {
//         const parts = rawRedirect.split("/");
//         const clientIdEncoded = parts[4];

//         try {
//           const clientId = atob(clientIdEncoded);

//           if (String(clientId) === String(userData?.id)) {
//             redirectPath = rawRedirect;
//           }
//         } catch (err) {
//         }
//       }
//     }

//     return <Navigate to={redirectPath} replace />;
//   }

//   // if single child (like your previous usage)
//   if (children) return children;

//   // if used as wrapper with Outlet
//   return <Outlet />;
// };

// export default PublicRoute;
